import React from "react";
import { formatarData } from "../../../../components/Formatters/DateTime";

const DebNaoPagosDivAtivaCard = ({ debitosNaoPagosDividaAtiva }) => (
  <div className="col-lg-12">
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>Débitos declarados e não pagos na dívida ativa</b>
      </div>
      <div className="card-body">
        <center>
          <table className="table table-striped table-bordered" width="100%">
            <thead>
              <tr>
                <th>
                  <center>Identificador PGE</center>
                </th>
                <th>
                  <center>Mês/Ano Vencimento</center>
                </th>
                <th>
                  <center>Receita</center>
                </th>
                <th>
                  <center>Valor Nominal</center>
                </th>
                <th>
                  <center>Multa</center>
                </th>
                <th>
                  <center>Juros</center>
                </th>
                <th>
                  <center>Valor total</center>
                </th>
                <th>
                  <center>Envio à PGE</center>
                </th>
              </tr>
            </thead>
            <tbody>
              {debitosNaoPagosDividaAtiva?.map((debito) => (
                <tr>
                  <td>
                    <center>{debito.identificadorPge}</center>
                  </td>
                  <td align="right">{debito.referencia}</td>
                  <td>
                    <center>{debito.siglaReceita}</center>
                  </td>
                  <td align="right">{debito.valorPrincipal.toLocaleString("pt-br", { minimumFractionDigits: 2 })}</td>
                  <td align="right">{debito.valorMora.toLocaleString("pt-br", { minimumFractionDigits: 2 })}</td>
                  <td align="right">{debito.valorJuros.toLocaleString("pt-br", { minimumFractionDigits: 2 })}</td>
                  <td align="right">{debito.valorTotal.toLocaleString("pt-br", { minimumFractionDigits: 2 })}</td>
                  <td>
                    <center>{formatarData(debito.dataEnvio, "dd/MM/yyyy")}</center>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={8}>
                  <center>
                    <b>
                      Total Nominal R${" "}
                      {debitosNaoPagosDividaAtiva
                        .reduce((total, debito) => total + debito.valorPrincipal, 0)
                        .toLocaleString("pt-br", { minimumFractionDigits: 2 })}{" "}
                      - Total Enviado R${" "}
                      {debitosNaoPagosDividaAtiva
                        .reduce((total, debito) => total + debito.valorTotal, 0)
                        .toLocaleString("pt-br", { minimumFractionDigits: 2 })}
                    </b>
                  </center>
                </td>
              </tr>
            </tfoot>
          </table>
        </center>
      </div>
    </div>
  </div>
);

export default DebNaoPagosDivAtivaCard;
